import { createContext, useContext } from 'react'

/**
 * The width the sidebar takes beside the page: the expanded drawer or the collapsed rail, and nothing on
 * phones, where it overlays the page. For pages that place fixed elements beside it. Provided by
 * AuthenticatedLayout, which owns the toggle.
 */
export const SidebarWidthContext = createContext<number | null>(null)

export function useSidebarWidth(): number {
    const width = useContext(SidebarWidthContext)
    if (width === null) throw new Error('useSidebarWidth is used outside AuthenticatedLayout')
    return width
}
